import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "page-title" }, "Liste des fournisseurs", -1)
const _hoisted_2 = { class: "flex justify-end" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "flex w-full" }
const _hoisted_5 = { class: "flex card-toolbar w-full" }
const _hoisted_6 = { class: "w-full" }
const _hoisted_7 = { class: "p-input-icon-left w-10/12" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_9 = { class: "justify-end ml-auto" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  value: ""
}, "Actions", -1)
const _hoisted_11 = { class: "flex w-full mt-6" }
const _hoisted_12 = { class: "ml-auto justify-end" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "card-body pt-0" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 0,
  class: "text-center bg-green-100 text-green-800 text-xs font-medium mr-2 px-2.5 py-0.5 rounded-full dark:bg-green-900 dark:text-green-300"
}
const _hoisted_18 = {
  key: 1,
  class: "text-center bg-red-100 text-red-800 text-xs font-medium mr-2 px-2.5 py-0.5 rounded-full dark:bg-red-900 dark:text-red-300"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", null, "Actions", -1)

import { ref, onMounted, watch, onBeforeMount } from "vue";
import ApiService from "@/_services/api.service";
import swal from "@/_helpers/swal";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import InputSwitch from "primevue/inputswitch";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import { fetchAllSuppliers, fetchSuppliers } from "@/_services/supplier/supplier";
import { ISortType } from "@/models/supplier/ISortType";
import { ISupplier } from "@/models/supplier/ISupplier";

import SupplierFormModal from "@/components/modal/supplier/SupplierFormModal.vue";
import router from "@/router";

const supplierFormModalId = "supplierFormModal";
const localStorageKey = "selectedSuppliers";
const enableGroupAction = "enable-by-group";
const disableGroupAction = "disable-by-group";
const enableOneAction = "enable-one";
const disableOneAction = "disable-one";
const defaultRowsPerPage = 10;

export default /*#__PURE__*/_defineComponent({
  __name: 'SupplierList',
  setup(__props) {

const isLoading = ref<boolean>(true);
const isInFilteredView = ref<boolean>(false);
const selectedGroupAction = ref<string>("");
const suppliers = Array<ISupplier>();
const tableData = ref<Array<ISupplier>>(suppliers);
const totalSelectedSuppliers = ref<number>(0);
const selectedSuppliers = ref(Array<ISupplier>());
const currentPage = ref<number>(0);
const rows = ref<number>(10);
const totalRecords = ref<number>(0);
const page = ref<number>(1);
const criteria = ref<string>("");
const isActiveUrlParam = ref<boolean | undefined>(undefined);
const sortFilterUrlParam = ref<Array<ISortType>>([]);
const rowsPerPageOptions = [defaultRowsPerPage, 25, 100];
const selectAll = ref(false);
onBeforeMount(() => {
    localStorage.removeItem(localStorageKey);
});

onMounted(async () => {
    totalSelectedSuppliers.value = selectedSuppliers.value.length;
    await populateDataTableWithLocalStorageFilters();
});

function onSearchInputDt() {
    let search = criteria.value.trim();
    showSpinner();
    populateDatatable(
        rows.value,
        page.value,
        "" != search ? search : "",
        sortFilterUrlParam.value,
        isActiveUrlParam.value
    );
}

const showSpinner = () => {
    isLoading.value = true;
}

const hideSpinner = () => {
    isLoading.value = false;
}

async function populateDatatable(
    itemsPerPage,
    page,
    criteria?,
    sort?: ISortType[] | undefined,
    isActive?: boolean | undefined
) {
    showSpinner();
    const [loadingDt, totalRecordsDt, tableDataDt] = await fetchSuppliers(
        itemsPerPage,
        page,
        criteria,
        sort,
        criteria !== "" ? criteria : undefined,
        isActive
    );
    totalRecords.value = totalRecordsDt.value;
    isLoading.value = loadingDt.value;
    tableData.value = tableDataDt.value;
}

async function populateDataTableWithLocalStorageFilters(
    itemsPerPage?: number,
    page?: number
) {
    let localStorageData = getLocalStorageData();
    if (null !== localStorageData) {
        let sortFilterFromLocalStorage = localStorageData.multiSortMeta;
        if (sortFilterFromLocalStorage.length <= 0) {
            setIsInFilteredView(false);
            isActiveUrlParam.value = undefined;
            sortFilterUrlParam.value = [];
        }

        if (sortFilterFromLocalStorage.length > 0) {
            setIsInFilteredView(true);
            sortFilterFromLocalStorage.forEach((item, index: number) => {
                if ("isActive" == item.field) {
                    isActiveUrlParam.value = [-1, 1].includes(item.order)
                        ? item.order === 1
                        : undefined;
                }
                if ("createdAt" == item.field) {
                    let isParamAlreadyExist = false;
                    let sort = item.order === 1 ? "asc" : "desc";
                    sortFilterUrlParam.value.forEach((param, index: number) => {
                        if ("order[createdAt]" == param.fieldLabel) {
                            isParamAlreadyExist = true;
                            param.fieldValue = sort;
                        }
                    });
                    if (!isParamAlreadyExist) {
                        sortFilterUrlParam.value.push({
                            fieldLabel: "order[createdAt]",
                            fieldValue: sort,
                        });
                    }
                }
                if ("createdBy" == item.field) {
                    let isParamAlreadyExist = false;
                    let sort = item.order === 1 ? "asc" : "desc";
                    sortFilterUrlParam.value.forEach((param, index: number) => {
                        if ("order[createdBy.firstname]" == param.fieldLabel) {
                            isParamAlreadyExist = true;
                            param.fieldValue = sort;
                        }
                    });
                    if (!isParamAlreadyExist) {
                        sortFilterUrlParam.value.push({
                            fieldLabel: "order[createdBy.firstname]",
                            fieldValue: sort,
                        });
                    }
                }
            });
        }
    }

    let localStorageRowPerPage = getLocalStorageRowsPerPage();
    let localStorageFisrtPageState = getLocalStorageFisrtPageState();
    let currentPage = page;
    if (!currentPage) {
        currentPage = localStorageFisrtPageState / localStorageRowPerPage + 1;
    }
    let currentItemsPerPage = itemsPerPage;
    if (!currentItemsPerPage) {
        currentItemsPerPage = localStorageRowPerPage;
    }

    populateDatatable(
        currentItemsPerPage,
        currentPage,
        criteria.value,
        sortFilterUrlParam.value,
        isActiveUrlParam.value
    );
}

function setIsInFilteredView(value: boolean) {
    isInFilteredView.value = value;
}

function onSort(e) {
    rows.value = e.rows;
    setLocalStorageRowsPerPage(rows.value);
    let sortFilter = e.multiSortMeta;
    if (sortFilter.length <= 0) {
        setIsInFilteredView(false);
        isActiveUrlParam.value = undefined;
        sortFilterUrlParam.value = [];
        populateDatatable(rows.value, page.value, criteria.value);
    }

    sortFilterUrlParam.value = [];
    if (sortFilter.length > 0) {
        setIsInFilteredView(true);
        sortFilter.forEach((item, index: number) => {
            if ("isActive" == item.field) {
                isActiveUrlParam.value = [-1, 1].includes(item.order)
                    ? item.order === 1
                    : undefined;
            }
            if ("createdAt" == item.field) {
                let isParamAlreadyExist = false;
                let sort = item.order === 1 ? "asc" : "desc";
                sortFilterUrlParam.value.forEach((param, index: number) => {
                    if ("order[createdAt]" == param.fieldLabel) {
                        isParamAlreadyExist = true;
                        param.fieldValue = sort;
                    }
                });
                if (!isParamAlreadyExist) {
                    sortFilterUrlParam.value.push({
                        fieldLabel: "order[createdAt]",
                        fieldValue: sort,
                    });
                }
            }
            if ("createdBy" == item.field) {
                let isParamAlreadyExist = false;
                let sort = item.order === 1 ? "asc" : "desc";
                sortFilterUrlParam.value.forEach((param, index: number) => {
                    if ("order[createdBy.firstname]" == param.fieldLabel) {
                        isParamAlreadyExist = true;
                        param.fieldValue = sort;
                    }
                });
                if (!isParamAlreadyExist) {
                    sortFilterUrlParam.value.push({
                        fieldLabel: "order[createdBy.firstname]",
                        fieldValue: sort,
                    });
                }
            }
        });

        populateDatatable(
            rows.value,
            page.value,
            criteria.value,
            sortFilterUrlParam.value,
            isActiveUrlParam.value
        );
    }
}

async function onPaginate(e) {
    showSpinner();
    rows.value = e.rows;
    page.value = e.page + 1;
    setLocalStorageRowsPerPage(rows.value);
    populateDataTableWithLocalStorageFilters(rows.value, page.value);
}

watch(selectedGroupAction, (newValue) => {
    if (enableGroupAction === newValue) {
        totalSelectedSuppliers.value <= 0
            ? swal.warning("Veuillez selectionner au moins un fournisseur")
            : checkSuppliersStatus(
                enableGroupAction,
                `Êtes-vous sûr de vouloir activer les (${totalSelectedSuppliers.value}) fournisseurs et produits associés ?`,
                `vous venez d'activer (${totalSelectedSuppliers.value}) fournisseurs et produits associés`,
                "Annuler",
                "Oui, activer",
                "btn btn-success",
                "btn btn-secondary"
            );
    }
    if (disableGroupAction === newValue) {
        totalSelectedSuppliers.value <= 0
            ? swal.warning("Veuillez selectionner au moins un fournisseur")
            : checkSuppliersStatus(
                disableGroupAction,
                `Êtes-vous sûr de vouloir désactiver les (${totalSelectedSuppliers.value}) fournisseurs et produits associés ?`,
                `vous venez de désactiver (${totalSelectedSuppliers.value}) fournisseurs et produits associés`,
                "Annuler",
                "Oui, désactiver",
                "btn btn-danger",
                "btn btn-secondary"
            );
    }
});



const onRowSelectAll = async () => {
    showSpinner();
    if(selectAll.value === false) {
        const [totalRecordsDt, tableDataDt] = 
            await fetchAllSuppliers();
        totalSelectedSuppliers.value = totalRecordsDt.value;
        totalRecords.value = totalRecordsDt.value;
        selectedSuppliers.value = tableDataDt.value;
        selectAll.value = true;
    } else {
        totalSelectedSuppliers.value = 0;
        selectAll.value = false;
        selectedSuppliers.value = [];
    }
    hideSpinner();
};

function onRowSelect() {
    totalSelectedSuppliers.value++;
}

function onRowUnselect() {
    totalSelectedSuppliers.value--;
}

function getLocalStorageData() {
    let storageData = localStorage.getItem(localStorageKey);
    
    if (null !== storageData && "undefined" !== storageData) {
        return JSON.parse(storageData);
    }

    return null;
}

function getSelectedSuppliersUuids() {
    let localStorageData = getLocalStorageData();
    let selectedSuppliersUuids = new Map();
    if (null !== localStorageData.selectionKeys) {
        selectedSuppliersUuids = new Map(
            Object.entries(localStorageData.selectionKeys)
        );
    }

    return selectedSuppliersUuids;
}

function setLocalStorageRowsPerPage(rowPerPage: number) {
    let storageData = localStorage.getItem(localStorageKey);
    if (null !== storageData) {
        let localStorageObject = JSON.parse(storageData);
        localStorageObject.rows = rowPerPage;
        localStorage.setItem(localStorageKey, JSON.stringify(localStorageObject));
    }
}

function getLocalStorageRowsPerPage() {
    let localStorageData = getLocalStorageData();
    if (null !== localStorageData && localStorageData.rows) {
        return localStorageData.rows;
    }

    return defaultRowsPerPage;
}

function getLocalStorageFisrtPageState() {
    let localStorageData = getLocalStorageData();
    if (null !== localStorageData && localStorageData.first) {
        return localStorageData.first;
    }

    return 0;
}

async function toggleSuppliersStatusByGroup(
    action: string,
    successMessage: string
) {
    let isActive = action === enableGroupAction;
    let selectedSuppliersUuids = getSelectedSuppliersUuids();
    const data = new Map();
    selectedSuppliersUuids.forEach((value, key) => {
        data.set(key, { uuid: key, isActive: isActive });
    });
    const mapDataIntoArray = Array.from(data.values());
    const dataToSendToApi = {
        suppliers: mapDataIntoArray,
    };

    showSpinner();
    await ApiService.patchWithoutSlug("suppliers", dataToSendToApi)
        .then(() => {
            swal.info(successMessage).then(() => {
                window.location.reload();
            });
        })
        .catch(() => {
            swal.error().then(() => {
                window.location.reload();
            });
        });
}

async function toggleOneSupplierStatus(
    action: string,
    uuid: string,
    successMessage: string
) {
    showSpinner();
    let isActive = action === enableOneAction;
    await ApiService.patchWithoutSlug("suppliers/" + uuid, { isActive: isActive })
        .then(() => {
            swal.info(successMessage).then(() => {
                window.location.reload();
            });
        })
        .catch(() => {
            swal.error();
        });
}

function checkSuppliersStatus(
    action: string,
    confirmMessage: string,
    successMessage: string,
    cancelButtonText?: string,
    confirmButtonText?: string,
    confirmButtonClass?: string,
    cancelButtonClass?: string,
    uuid?: string
) {
    swal
        .confirm(
            confirmMessage,
            cancelButtonText,
            confirmButtonText,
            confirmButtonClass,
            cancelButtonClass
        )
        .then((result) => {
            if (result.isConfirmed) {
                if ([enableGroupAction, disableGroupAction].includes(action)) {
                    toggleSuppliersStatusByGroup(action, successMessage);
                }
                if ([enableOneAction, disableOneAction].includes(action) && uuid) {
                    toggleOneSupplierStatus(action, uuid, successMessage);
                }
            } else {
                window.location.reload();
            }
        });
}

const supplierUuid = ref<string>("");

const setUuidAndOpenModal = (uuid: string) => {
    supplierUuid.value = uuid;
    const supplierFormModalElement:HTMLDialogElement | null = document.querySelector(`#${supplierFormModalId}`);
    if (supplierFormModalElement) {
        supplierFormModalElement.showModal();
    }
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Button), {
        label: "Ajouter un fournisseur",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (setUuidAndOpenModal(''))),
        icon: "pi pi-plus",
        "aria-label": "Ajouter un fournisseur",
        class: "button-add"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(DataTable), {
        lazy: "",
        dataKey: "uuid",
        stateStorage: "local",
        ref: "dt",
        "state-key": localStorageKey,
        value: tableData.value,
        paginator: true,
        rows: rows.value,
        rowHover: true,
        sortMode: "multiple",
        removableSort: "",
        selection: selectedSuppliers.value,
        "onUpdate:selection": _cache[4] || (_cache[4] = ($event: any) => ((selectedSuppliers).value = $event)),
        metaKeySelection: false,
        loading: isLoading.value,
        totalRecords: totalRecords.value,
        currentPage: currentPage.value,
        paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
        rowsPerPageOptions: rowsPerPageOptions,
        currentPageReportTemplate: "Affichage de {first} à {last} sur {totalRecords} entrées",
        selectAll: selectAll.value,
        onSelectAllChange: _cache[5] || (_cache[5] = ($event: any) => (onRowSelectAll())),
        onRowSelect: _cache[6] || (_cache[6] = ($event: any) => (onRowSelect())),
        onRowUnselect: _cache[7] || (_cache[7] = ($event: any) => (onRowUnselect())),
        onPage: _cache[8] || (_cache[8] = ($event: any) => (onPaginate($event))),
        onSort: _cache[9] || (_cache[9] = ($event: any) => (onSort($event)))
      }, {
        loading: _withCtx(() => [
          _createTextVNode(" Chargement... ")
        ]),
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_unref(InputText), {
                    type: "text",
                    class: "w-64",
                    modelValue: criteria.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((criteria).value = $event)),
                    placeholder: "Recherche par fournisseur",
                    onInput: _cache[2] || (_cache[2] = ($event: any) => (onSearchInputDt()))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedGroupAction).value = $event)),
                class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              }, [
                _hoisted_10,
                _createElementVNode("option", { value: enableGroupAction }, "Activer"),
                _createElementVNode("option", { value: disableGroupAction }, "Désactiver")
              ], 512), [
                [_vModelSelect, selectedGroupAction.value]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("p", null, "Nombre total de fournisseurs : " + _toDisplayString(totalRecords.value), 1),
              _createElementVNode("p", null, " Nombre de ligne sélectionnée(s) : " + _toDisplayString(totalSelectedSuppliers.value), 1),
              (isInFilteredView.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_13, "Vous êtes en vue filtrée"))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        empty: _withCtx(() => [
          _createTextVNode("Aucun résultat trouvé.")
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_unref(Column), { selectionMode: "multiple" }),
            _createVNode(_unref(Column), {
              field: "name",
              header: "Fournisseur"
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("span", null, _toDisplayString(slotProps.data.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "fees",
              header: "Frais de gestion"
            }, {
              body: _withCtx((slotProps) => [
                (slotProps.data.fees != null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(slotProps.data.fees), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_16, "Non"))
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "createdAt",
              header: "Date de création",
              sortable: ""
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("span", null, _toDisplayString(slotProps.data.createdAt), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "createdBy",
              header: "Créé par",
              sortable: ""
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("span", null, _toDisplayString(slotProps.data.createdBy), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "isActive",
              header: "État",
              sortable: ""
            }, {
              body: _withCtx((slotProps) => [
                (slotProps.data.isActive)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, " Actif "))
                  : (_openBlock(), _createElementBlock("div", _hoisted_18, " Inactif "))
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { headerStyle: "width: 12em;" }, {
              header: _withCtx(() => [
                _hoisted_19
              ]),
              body: _withCtx((slotProps) => [
                _createVNode(_unref(Button), {
                  size: "small",
                  icon: "pi pi-eye",
                  class: _normalizeClass(["p-button-eye", `${slotProps.data.uuid}`]),
                  style: {"margin-right":"0.5em"},
                  title: "Voir",
                  onClick: ($event: any) => (_unref(router).push({ name: 'supplierDetail', params: { uuid: slotProps.data.uuid } }))
                }, null, 8, ["class", "onClick"]),
                _createVNode(_unref(Button), {
                  size: "small",
                  icon: "pi pi-pencil",
                  class: _normalizeClass(["p-edition", `${slotProps.data.uuid}`]),
                  style: {"margin-right":"0.5em"},
                  title: "Éditer",
                  onClick: ($event: any) => (setUuidAndOpenModal(slotProps.data.uuid))
                }, null, 8, ["class", "onClick"]),
                _createVNode(_unref(InputSwitch), {
                  modelValue: slotProps.data.isActive,
                  "onUpdate:modelValue": ($event: any) => ((slotProps.data.isActive) = $event),
                  "input-id": slotProps.data.uuid,
                  onInput: ($event: any) => (
                            checkSuppliersStatus(
                                slotProps.data.isActive ? enableOneAction : disableOneAction,
                                slotProps.data.isActive
                                    ? `Êtes-vous sûr de vouloir activer le fournisseur et produits associés ?`
                                    : `Êtes-vous sûr de vouloir désactiver le fournisseur et produits associés ?`,
                                slotProps.data.isActive
                                    ? `vous venez d'activer 1 fournisseur et les produits associés`
                                    : `vous venez de désactiver 1 fournisseur et les produits associés`,
                                `Annuler`,
                                slotProps.data.isActive ? `Oui, activer` : `Oui, désactiver`,
                                slotProps.data.isActive
                                    ? `btn btn-success`
                                    : `btn btn-danger`,
                                `btn btn-secondary`,
                                slotProps.data.uuid
                            )
                            )
                }, null, 8, ["modelValue", "onUpdate:modelValue", "input-id", "onInput"])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["value", "rows", "selection", "loading", "totalRecords", "currentPage", "selectAll"]),
      _createVNode(SupplierFormModal, {
        "supplier-uuid": supplierUuid.value,
        "supplier-form-modal-id": supplierFormModalId
      }, null, 8, ["supplier-uuid"])
    ])
  ], 64))
}
}

})